import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchDemand from "@/views/审核管理/model/search/DZSearchDemand";
import DZModelAddress from "@/views/审核管理/model/DZModelAddress";
import DZModelContacts from "@/views/审核管理/model/DZModelContacts";
import DZModelDemandBase from "@/views/审核管理/model/DZModelDemandBase";
import DZModelListDemand from "@/views/审核管理/model/list/DZModelListDemand";

class DZServiceDemand{

    m_search = new DZSearchDemand(10);

    /** 需求审核列表 **/
    list_demand : Array<DZModelListDemand> = [];

    /** 需求基本信息 **/
    base = new DZModelDemandBase();
    /** 位置 **/
    address = new DZModelAddress();
    /** 联系人 **/
    contact = new DZModelContacts();
    sum = {
        all:'',
        listed:'',
        delisted:'',
        unaudited:''
    }


    net_page_demand(){
        let arr = this.m_search.countyArr
        if(arr.length != 0){
            this.m_search.level = String(arr.length)
            this.m_search.county = arr[arr.length-1]
        }
        nyNetwork.net("需求信息审核列表",this.m_search, data => {
            this.list_demand = data.list
            this.m_search.total = data.total
        })
        nyNetwork.net("需求信息审核列表统计",this.m_search, res => {
            if(res){
                this.sum.all = res.all
                this.sum.listed = res.listed
                this.sum.delisted = res.delisted
                this.sum.unaudited = res.unaudited
            }
        })
    }

    net_demand_info(id){
        nyNetwork.net("需求信息详情",{id:id}, data => {
            this.base = data.baseInfo
            this.address = data.addressInfo
            this.contact = data.contactsInfo
        })
    }

    net_edit_demand_base(m_base){
        nyNetwork.net("修改需求基本信息",m_base, data => {
            //success()
        })
    }

    net_edit_address(m_address){
        nyNetwork.net("修改需求位置",m_address, data => {
            //success()
        })
    }

    net_edit_contact(m){
        nyNetwork.net("修改需求联系人",m, data => {
            //success()
        })
    }

    net_demand_pass(id,success: () => void){
        nyNetwork.net("需求审核通过",{id:id}, data => {
            success()
        })
    }

    net_demand_refuse(id,success: () => void){
        nyNetwork.net("需求审核拒绝",{id:id}, data => {
            success()
        })
    }

    net_demand_operate(id,success: () => void){
        nyNetwork.net("需求暂停/继续发布",{id:id}, data => {
            success()
        })
    }

    net_batch_deList(idList,success: () => void){
        nyNetwork.net("需求批量下架",[...idList], data => {
            success()
        })
    }

}
export default DZServiceDemand;
